// extracted by mini-css-extract-plugin
export default {"btn":"BackToTop_btn__qzx1h","visible":"BackToTop_visible__l6pyZ"};